import React, { useState, useEffect } from "react";
import { css } from "emotion";
import { useNewOffer } from "../../context/new-offer";

import CardInfoFidelityProgramDetails from "../../../shared/create-offer/CardInfoFidelityProgramDetails/CardInfoFidelityProgramDetails";
import { pageOfferMiles } from "./style";
import BoxOfferMiles from "../../../shared/create-offer/BoxOfferMiles/BoxOfferMiles";
import {
	ItemCardInfoRanking,
	ItemCardInfoMilesReductionTickets,
	ItemCardInfoAverageMilesPerTicket,
	ItemCardInfoQuantOfferMiles,
	ItemCardInfoBank,
	ItemCardInfoRescuePassMultiplus,
	ItemCardInfoPhoneMultiplus,
	ItemCardInfoDefault
} from "../../../shared/create-offer/ItemsCardInfoFidelityProgramDetails";
import MessageBar from "../../../shared/create-offer/MessageBar/MessageBar";
import LayoutSticky from "../molecules/LayoutSticky";
import { MINIMAL_MILES_ADVANCED_AVERAGE, AIRLINE_PROGRAMS } from "../../shared/enums";
import { ItemCardInfo2FA } from "../../../shared/create-offer/ItemsCardInfoFidelityProgramDetails/ItemCardInfo2FA";
import { GOL_FIDELITY_PROGRAM } from "../../../../js/shared/constants";

const OfferMiles = props => {
	const [inputInFocus, setInputInFocus] = useState("");

	const {
		currentProgram,
		newOfferTempData,
		userData,
		rankingData,
		setNewOfferTempData,
		phoneMultiplus,
		airlineProgramsSettings,
		bonusData: { data: bonusData }
	} = useNewOffer();

	const golAirlineProgramsSettings = airlineProgramsSettings && Object.values(airlineProgramsSettings).find(item => item.idAirlinesProgram === GOL_FIDELITY_PROGRAM);

	const checkData = (box, value) => {
		setNewOfferTempData({
			...newOfferTempData,
			form: {
				...newOfferTempData.form,
				[box]: value
			}
		});
	};

	const getAdvancedConfigMinMiles = () =>
		bonusData && bonusData.enabled ? bonusData.minMiles : MINIMAL_MILES_ADVANCED_AVERAGE;

	const renderCardInfo = rankingData => {
		const inputFocusValidation = props.typePhoneLatam !== 1 ? "phone" : "phoneDisabled";
		switch (inputInFocus) {
			case "priceOfferMiles":
				return <ItemCardInfoRanking rankingData={rankingData} />;
			case "milesReductionTickets":
				return <ItemCardInfoMilesReductionTickets />;
			case "averageMilesPerTicket":
			case "averageOfferMiles":
				return <ItemCardInfoAverageMilesPerTicket minMilesAdvanced={getAdvancedConfigMinMiles()} />;
			case "bankId":
			case "cpfcnpj":
			case "agency":
			case "account":
				return <ItemCardInfoBank />;
			case "pwAwardSecondary":
				return <ItemCardInfoRescuePassMultiplus />;
			case inputFocusValidation:
				return <ItemCardInfoPhoneMultiplus phoneMultiplus={phoneMultiplus} />;
			case "user":
			case "password":
				return <ItemCardInfoDefault fidelityProgram={currentProgram} />;
			case "phoneTwoFactorGol":
				return <ItemCardInfoDefault fidelityProgram={currentProgram} />;
			case "twoFactorAuthenticationStrategy":
				return <ItemCardInfo2FA title={golAirlineProgramsSettings.helpTitle} description={golAirlineProgramsSettings.helpDescription} />
			case "quantOfferMiles":
			default:
				return <ItemCardInfoQuantOfferMiles minMilesAdvanced={getAdvancedConfigMinMiles()} />;
		}
	};

	return (
		<div
			className={css`
				${pageOfferMiles}
			`}
		>
			<div className="layout">
				<div className="layout-offer-miles">
					<BoxOfferMiles
						setInputInFocus={setInputInFocus}
						inputInFocus={inputInFocus}
						checkData={checkData}
						typePhoneLatam={props.typePhoneLatam}
					/>
				</div>
				<div className="layout-card-ranking">
					<LayoutSticky>
						<CardInfoFidelityProgramDetails children={renderCardInfo(rankingData)} />
					</LayoutSticky>
				</div>
			</div>
			{(currentProgram.international === "0" || currentProgram.id === AIRLINE_PROGRAMS.TAP.id) && <MessageBar />}
		</div>
	);
};

export default OfferMiles;
